import { sendPostRequest } from './index';
import { apiCategory } from './api/category';

export const getCategory = (param: any) => sendPostRequest(apiCategory.getCategory, param);
